module.exports = __webpack_public_path__ + "static/brentprofile-8cffa61b90c616a566c353ab564e5e00.jpg";